import { CRMChannel, CRMConfig } from "@jugl-web/rest-api";
import sortBy from "lodash/sortBy";

type SortableChannelId = CRMChannel | "live-chat";

const getChannelInsertedAt = (
  channelId: SortableChannelId,
  crmConfig?: CRMConfig
): string => {
  if (!crmConfig) {
    return "";
  }

  if (channelId === "live-chat") {
    return crmConfig.livechat?.inserted_at ?? "";
  }

  return crmConfig[channelId]?.inserted_at ?? "";
};

export const sortConnectedChannels = <T extends { id: SortableChannelId }>(
  channels: T[],
  crmConfig?: CRMConfig
): T[] => {
  const chatbotChannel = channels.find(
    (channel) => channel.id === CRMChannel.chatbot
  );
  const otherChannels = sortBy(
    channels.filter((channel) => channel.id !== CRMChannel.chatbot),
    (channel) => getChannelInsertedAt(channel.id, crmConfig)
  ).reverse();

  return chatbotChannel ? [chatbotChannel, ...otherChannels] : otherChannels;
};
